<template>
    <div>
        <false-dashboard>
            <div class="mt-5 pt-5 ml-lg-5 pl-lg-5 ml-md-2">
                <div class="">
                    <!-- <div class="text-center" v-if="loading">
                        <p>loading...</p>
                    </div> -->
                    <div class="col-lg-6 col-md-12 m-0 p-0">
                        <h6 class=" pb-3">Confirm Email Address</h6>
                        <div class="card shadow-sm border-0">
                            <div class="card-body p-0 m-0">
                                <!-- <img src="@/assets/placeholder.png" alt="" style="width: 100%; height: 200px;"> -->
                                <div class="body-card px-lg-4 px-3 py-4">
                                    <div class="">
                                        <div>
                                            <form @submit.prevent="confirmEmailAddress()">
                                                <div class="form-group mb-2">
                                                    <label for="" class="mb-1"><small>Email Address</small></label>
                                                    <input class="form-control" v-model="form.email" type="email" required >
                                                </div>

                                                <div class="form-group">
                                                    <div class="mt-4">
                                                        <button class="btn btn-custom btn-block btn-lg" type="submit">Confirm email</button>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </false-dashboard>
    </div>
</template>

<script>
import FalseDashboard from '@/components/FalseDashboard'

export default {
    data() {
        return {
            pool_id: this.$route.params.pool_id,
            form: {
                email: ''
            }
        }
    },
    components: {
        FalseDashboard
    },
    created() {
        this.$store.dispatch('getPool', this.pool_id);
    },
    computed: {
        pool() {
            return this.$store.getters.pool
        }
    },
    methods: {
        async confirmEmailAddress() {
            // check if the user is a member of this pool first
            let pool_member  = this.pool.invitees.filter(invitee => invitee.email == this.form.email);

            // if the user is not a part of the pool
            if (pool_member.length == 0) {

                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Sorry, you are not a member of this pool'
                });
                
                return false;
            }

            // if the user is part of the pool
            if (pool_member.length > 0) {
                // check if the user has completed his signup
                try {
                    const user = await axios.post('/auth/loginViaEmail', { email: this.form.email }, { errorHandle: false });

                    // user has not completed signup
                    if (user.status == 400) {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Error',
                            text: 'Please kindly complete your registration by following the pool invite link sent to your mail'
                        });
                    }

                    // if user is valid and has completed his registration
                    if (user.status == 200) {

                        const { access_token, expires_in, token_type } = user.data;

                        localStorage.setItem('access_token', access_token);
                        localStorage.setItem('expires_in', expires_in);
                        localStorage.setItem('token_type', token_type);

                        const headers = { Authorization: `Bearer ${access_token}`};

                        const logged_in_user = await axios.post('/auth/me', {}, { headers });
                        
                        if (logged_in_user.status == 200) {
                            localStorage.setItem('user', JSON.stringify(logged_in_user.data));

                            // set axios authorization header
                            axios.defaults.headers.Authorization = `Bearer ${access_token}`;  

                            // redirect to the pool page
                            window.location.href = '/mypools/'+ this.pool_id;
    
                            // this.$router.push({ 
                            //     name: 'viewpool', 
                            //     params: { pool_id: this.pool_id }
                            // });
                        }
                    }
                    
                } catch (error) {
                    //
                }
    
            }
            
            // if true and false, tell the person to go and complete the pool signup
        }
    }

}
</script>

<style>

</style>